import { useParams } from "react-router";
import {
  BreadCrumb,
  ApiLoadingSpinner,
  ApiUpdatingSpinner,
  Title,
} from "@funcional/react-ui";
import { PreTransactionCard } from "@pbm/transactions/components";
import { usePreTransaction } from "@pbm/transactions/hooks";

export default function ViewPreTransactionPage() {
  let { id }: { id: string } = useParams();
  const { status, data, error, isFetching } = usePreTransaction(id);
  return (
    <>
      <Title>Pré-transação #{id}</Title>

      <BreadCrumb
        items={[
          {
            path: "/pbm/pre-transactions",
            label: "Pré-transações",
          },
          { label: `#${id}` },
        ]}
      />

      {status === "loading" ? (
        <ApiLoadingSpinner />
      ) : status === "error" ? (
        <span>Erro: {error}</span>
      ) : (
        <>
          {data ? (
            <PreTransactionCard transaction={data} />
          ) : (
            <p>Pré-transação não encontrada.</p>
          )}
          {isFetching ? <ApiUpdatingSpinner /> : null}
        </>
      )}
    </>
  );
}
